import { useEffect } from "react";

/**
 * Keep the app shell pinned to the visible area on touch devices.
 *
 * iOS Safari does not shrink the layout viewport when the on-screen keyboard
 * opens; it scrolls the whole document so the focused field clears the
 * keyboard, pushing the header off-screen. Instead, publish the visual
 * viewport height as `--app-height` (the shell sizes itself from it, so the
 * focused field is already above the keyboard) and undo any document scroll.
 */
export const useVisualViewportLock = () => {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport || !window.matchMedia("(pointer: coarse)").matches) return;

    const root = document.documentElement;
    const sync = () => {
      // Leave pinch-zoom panning alone
      if (viewport.scale > 1) return;
      root.style.setProperty("--app-height", `${viewport.height}px`);
      if (window.scrollY !== 0) window.scrollTo(0, 0);
    };

    sync();
    viewport.addEventListener("resize", sync);
    viewport.addEventListener("scroll", sync);
    window.addEventListener("scroll", sync);
    return () => {
      viewport.removeEventListener("resize", sync);
      viewport.removeEventListener("scroll", sync);
      window.removeEventListener("scroll", sync);
      root.style.removeProperty("--app-height");
    };
  }, []);
};
